import React, { useState } from "react";
import { IResourceComponentsProps, useGetIdentity, useList, useMany } from "@pankod/refine-core";
import { Form, FormProps, Input, Modal, ModalProps, Select, SelectProps } from "@pankod/refine-antd";
import { useUserContext } from "context/user";
import { ICondition } from "interfaces";
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;
type CreateRuleProps = {
    modalProps: ModalProps
    formProps: FormProps
  }
export const CreateRetireRule: React.FC<CreateRuleProps> = ({modalProps,formProps}) => {
    const { data: user } = useGetIdentity()
    const { userRole } = useUserContext()
    const [showCount,setShowCount]=useState(false)
    const [showdateRange,setShowDateRange]=useState(false)
    const onFinish = async (values: any) => {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          created_by: user?.id
  
        })
      )
    }
    const { data, isLoading, isError } = useList<ICondition>({
        resource: "rule_conditions",
        metaData:{
            fields:['id','name','key','rule_id']
        }
    
    });

    const conditions = data?.data ?? [];
    console.log({conditions})
    const options: SelectProps['options'] = [];

    for (let i = 1; i <= 50; i++) {
      options.push({
        value: i.toString(),
        label: i.toString(),
      });
    }
    const toggleShowCount=(value:any)=>{
        console.log("values",value)
        if(value==='discrimantion_index_count' || value==='paper_count' || value==='discrimantion_index'){
          setShowDateRange(false)
            setShowCount(true)
        }
        else if(value==="creation_date"){
          setShowCount(false)
          setShowDateRange(true)
        }
        else{
          setShowDateRange(false)
            setShowCount(false)
        }

    }
    return(
        <Modal {...modalProps} title="Create Rule">
        <Form {...formProps} size="large" layout="vertical" onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            // if (response) {
            //   createUserHistory('sections', 'create', response?.data?.id, user?.id, userRole)
            // }
  
          })
  
          return response
        }}>
          <Form.Item
            label="Rule Name"
            name="name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Criteria"
            name="condition_attribute"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select  onChange={toggleShowCount} filterOption={(inputValue, option:any) =>
    option?.children?.join('').toLowerCase().includes(inputValue.toLowerCase())
  }>
            {conditions.map((condition) => (
                <option key={condition.key} value={condition.rule_id}>
            
                        {condition.name}
                  
                </option>
            ))}
            </Select>
            
          {/* <Select onChange={toggleShowCount} options={[
        {
          value: 'creation_date',
          label: 'Question creation date',

        },
        {
          value: 'discrimantion_index',
          label: 'By discremination index',
        },
        {
          value: 'discrimantion_index_count',
        //   disabled: true,
          label: 'How many times the DI can be <=0 and <1',
        },
        {
          value: 'paper_count',
          label: 'How many times a question can be used in different papers',
        },
      ]}/> */}
        
        </Form.Item>
        <Form.Item
        hidden={!showdateRange}
            label="Date range"
            name="date_range"
            rules={[
              {
                required: false,
              },
            ]}
          >
        <RangePicker />
        </Form.Item>
        
        <Form.Item
        hidden={!showCount}
            label="Count"
            name="count"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Duration Range"
            name="duration_unit"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select options={[
        {
          value: 'days',
          label: 'Days',
        },
        {
          value: 'months',
          label: 'Months',
        },
        {
          value: 'years',
        //   disabled: true,
          label: 'Years',
        },
        
      ]}/>
        
        </Form.Item>
        <Form.Item
            label="Duration"
            name="duration"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select  tokenSeparators={[',']}
    options={options}/>
        
        </Form.Item>
        <Form.Item
            label="Status"
            name="active"
            rules={[
              {
                required: true,
              },
            ]}
          >
            
          <Select options={[
        {
          value: true,
          label: 'Activate',
        },
        {
          value: false,
          label: 'Deactivate',
        },
       
        
      ]}/>
        
        </Form.Item>
          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Form>
      </Modal>
    )
}